/* eslint-disable */
export default {
  _background_level0: 'background_level0',
  _background_level1: 'background_level1',
  _rocket: 'rocket',
  _man_rocket: 'man_rocket',
  _AMPM_Bg: 'AMPM_Bg',
  _SunPopup: 'SunPopup',
  _Select_Digital: 'Select_Digital',
  _moon: 'moon',
  _big_hand: 'big_hand',
  _small_hand: 'small_hand',
  _progress2: 'progress2',
  _progress_background: 'progress_background',
  _analog_clock_face: 'analog_clock_face',
  _digital_clock_face: 'digital_clock_face',
  _progress4: 'progress4',
  _MoonPopup: 'MoonPopup',
  _cat_0: 'cat/0',
  _info_button: 'info_button',
  _puff: 'puff',
  _progress5: 'progress5',
  _progress6: 'progress6',
  _progress7: 'progress7',
  _progress8: 'progress8',
  _progress9: 'progress9',
  _progress10: 'progress10',
  _progress1: 'progress1',
  _progress3: 'progress3',
  _Select_Analog: 'Select_Analog',
  _analog_clock: 'analog_clock',
  _menu_button: 'menu_button',
  _pm_button: 'pm_button',
  _flames: 'flames',
  _play_button: 'play_button',
  _man_in_window: 'man_in_window',
  _select_button0: 'select_button0',
  _sun: 'sun',
  _check_button: 'check_button',
  _cat_1: 'cat/1',
  _cat_2: 'cat/2',
  _background_level2: 'background_level2',
  _background_level3: 'background_level3',
  _rocket2: 'rocket2',
  _man: 'man',
  _digital_clock: 'digital_clock',
  _select_button1: 'select_button1',
  _select_button2: 'select_button2',
  _select_button3: 'select_button3',
  _select_button4: 'select_button4',
  _select_button_lock: 'select_button_lock',
  _cat_in_window: 'cat_in_window',
  _cat_88: 'cat/88',
  _cat_89: 'cat/89',
  _play_again_button: 'play_again_button',
  _cat_90: 'cat/90',
  _cat_87: 'cat/87',
  _cat_91: 'cat/91',
  _cat_86: 'cat/86',
  _cat_92: 'cat/92',
  _cat_3: 'cat/3',
  _cat_85: 'cat/85',
  _cat_23: 'cat/23',
  _cat_93: 'cat/93',
  _cat_4: 'cat/4',
  _cat_8: 'cat/8',
  _cat_24: 'cat/24',
  _cat_43: 'cat/43',
  _cat_44: 'cat/44',
  _cat_45: 'cat/45',
  _cat_25: 'cat/25',
  _cat_21: 'cat/21',
  _cat_22: 'cat/22',
  _button_down: 'button_down',
  _cat_46: 'cat/46',
  _cat_20: 'cat/20',
  _cat_42: 'cat/42',
  _cat_47: 'cat/47',
  _cat_26: 'cat/26',
  _cat_41: 'cat/41',
  _cat_48: 'cat/48',
  _cat_14: 'cat/14',
  _cat_13: 'cat/13',
  _cat_15: 'cat/15',
  _cat_16: 'cat/16',
  _cat_5: 'cat/5',
  _cat_10: 'cat/10',
  _cat_19: 'cat/19',
  _cat_17: 'cat/17',
  _cat_11: 'cat/11',
  _cat_12: 'cat/12',
  _button_up: 'button_up',
  _cat_6: 'cat/6',
  _cat_7: 'cat/7',
  _cat_9: 'cat/9',
  _cat_94: 'cat/94',
  _cat_75: 'cat/75',
  _cat_76: 'cat/76',
  _cat_18: 'cat/18',
  _cat_77: 'cat/77',
  _cat_27: 'cat/27',
  _cat_40: 'cat/40',
  _cat_63: 'cat/63',
  _cat_49: 'cat/49',
  _speaker_off: 'speaker_off',
  _cat_51: 'cat/51',
  _cat_78: 'cat/78',
  _cat_79: 'cat/79',
  _cat_52: 'cat/52',
  _cat_50: 'cat/50',
  _cat_66: 'cat/66',
  _cat_67: 'cat/67',
  _cat_101: 'cat/101',
  _cat_102: 'cat/102',
  _cat_53: 'cat/53',
  _cat_54: 'cat/54',
  _cat_68: 'cat/68',
  _cat_28: 'cat/28',
  _cat_55: 'cat/55',
  _cat_38: 'cat/38',
  _cat_95: 'cat/95',
  _cat_69: 'cat/69',
  _cat_84: 'cat/84',
  _cat_100: 'cat/100',
  _cat_56: 'cat/56',
  _cat_70: 'cat/70',
  _cat_39: 'cat/39',
  _cat_57: 'cat/57',
  _cat_72: 'cat/72',
  _cat_71: 'cat/71',
  _cat_99: 'cat/99',
  _cat_29: 'cat/29',
  _cat_37: 'cat/37',
  _cat_65: 'cat/65',
  _cat_82: 'cat/82',
  _cat_73: 'cat/73',
  _cat_30: 'cat/30',
  _cat_31: 'cat/31',
  _cat_32: 'cat/32',
  _cat_34: 'cat/34',
  _cat_62: 'cat/62',
  _cat_35: 'cat/35',
  _cat_74: 'cat/74',
  _cat_80: 'cat/80',
  _cat_33: 'cat/33',
  _cat_36: 'cat/36',
  _cat_83: 'cat/83',
  _cat_98: 'cat/98',
  _cat_58: 'cat/58',
  _cat_64: 'cat/64',
  _cat_81: 'cat/81',
  _cat_97: 'cat/97',
  _cat_59: 'cat/59',
  _speaker_on: 'speaker_on',
  _cat_61: 'cat/61',
  _cat_60: 'cat/60',
  _cat_96: 'cat/96',
  _next_button: 'next_button',
  _background_level4: 'background_level4',
  _bonus_background: 'bonus_background',
  _choose_clock_background: 'choose_clock_background',
  _intro_background: 'intro_background',
  _select_background: 'select_background',
}